import React from 'react';

import Button from '@hero/ui-kit/inputs/Button';
import P from '@hero/ui-kit/typography/P';

import useCareReadiness from '../api/useCareReadiness';
import { careErrorText } from '../constants';
import * as Style from '../style.module.scss';
import CareTable from './CareTable';
import FailedChecks from './FailedChecks';

const ReadinessPanel: React.FC<{ month: string }> = ({ month }) => {
    const { data, error, isFetching, refetch } = useCareReadiness(month);

    return (
        <>
            <Button
                size="small"
                variant="outlineSecondary"
                width="natural"
                noDefaultMargin
                className={Style.readinessButton}
                disabled={isFetching}
                onClick={() => refetch()}
            >
                {isFetching ? 'Checking…' : 'Check before locking'}
            </Button>
            {error ? (
                <P className={Style.apiError} noDefaultMargin>
                    {careErrorText(error)}
                </P>
            ) : null}
            {/* After a failed check, an older result is not shown as the current decision. */}
            {isFetching || (data && !error) ? (
                <CareTable
                    title={
                        data
                            ? data.ready
                                ? 'Ready to lock'
                                : 'Not ready to lock'
                            : 'Lock readiness'
                    }
                    columns={['Checks']}
                    gridTemplateColumns="1fr"
                    loading={isFetching}
                    rows={
                        data
                            ? [
                                  [
                                      data.ready ? (
                                          'Every lock check passed.'
                                      ) : (
                                          <FailedChecks key="failed" checks={data.checks} />
                                      )
                                  ]
                              ]
                            : undefined
                    }
                    explanations={data ? [data.warnings.icd10_missing.explanation] : []}
                />
            ) : (
                <P size="small">
                    Check whether this month is ready to lock and see what still needs attention.
                </P>
            )}
        </>
    );
};

export default ReadinessPanel;
